module.exports = __webpack_public_path__ + "static/media/404page.4ee4f99f.png";